import get from 'lodash/get';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import type { RouterDataContext } from '@atlassian/react-resource-router';

export const getProjectKeyFromContext = (
	match: RouterDataContext['match'],
	query: RouterDataContext['query'],
): string =>
	getProjectKeyId(match, query).projectKey || get(match, 'params.issueKey', '').split('-')[0];
